// export const validateMobileNumber = (value, setState) => {
//   // Remove all non-numeric characters
//   let cleanedValue = value.replace(/[^0-9]/g, '');

//   // If value starts with '03' and has 11 or fewer digits, allow it
//   if (cleanedValue.startsWith('03') && cleanedValue.length <= 11) {
//     setState(cleanedValue);
//   }
//   // If value starts with '923' and has 12 or fewer digits, allow it
//   else if (cleanedValue.startsWith('923') && cleanedValue.length <= 12) {
//     setState(cleanedValue);
//   }
//   // If value starts with '03' or '923' but has more than the allowed number of digits, don't allow further input
//   else if (cleanedValue.length < 12) {
//     setState(cleanedValue);
//   }
// };

export const validateMobileNumber = (value, setState) => {
  // Remove all non-numeric characters
  let cleanedValue = value.replace(/[^0-9]/g, '');

  // If value starts with '03' and has exactly 11 digits, allow it
  if (cleanedValue.startsWith('03') && cleanedValue.length === 11) {
    setState(cleanedValue);
    return true; // Valid
  }
  // If value starts with '923' and has exactly 12 digits, allow it
  else if (cleanedValue.startsWith('923') && cleanedValue.length === 12) {
    setState(cleanedValue);
    return true; // Valid
  }
  // Otherwise, don't allow further input
  else {
    setState(cleanedValue);
    return false; // Invalid
  }
};

export const validateEmail = (value, setState, setIsValid) => {
  setState(value);
  const emailPattern = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
  setIsValid(emailPattern.test(value) || value === '');
};